import AdminLogging from '../../components/logging/admin-logging/AdminLogging';

const LoggingPage = () => {
  return <AdminLogging />;
};

export default LoggingPage;
